(() => {
  'use strict';

  const PREFIX = '[FTR Loop Parent Meta]';
  let installTimer = null;

  function getPageMeta() {
    const meta = window.FTRBundleProductMeta || {};
    return {
      title: String(meta.title || '').trim(),
      url: String(meta.url || '').trim(),
      image: String(meta.image || '').trim()
    };
  }

  function persistMeta(bundleId, meta) {
    if (!bundleId) return;
    try {
      sessionStorage.setItem(`ftr-loop-bundle-meta:${bundleId}`, JSON.stringify(meta));
      if (meta.url) sessionStorage.setItem(`ftr-loop-bundle-url:${bundleId}`, meta.url);
      if (meta.title) sessionStorage.setItem(`ftr-loop-bundle-name:${bundleId}`, meta.title);
    } catch (_) {}
  }

  function attachMeta(items) {
    if (!Array.isArray(items)) return items;
    const meta = getPageMeta();
    if (!meta.title && !meta.url && !meta.image) return items;

    return items.map((item) => {
      const bundleId = item?.properties?._bundleId;
      if (!bundleId) return item;

      persistMeta(String(bundleId), meta);
      return {
        ...item,
        properties: {
          ...(item.properties || {}),
          ...(meta.title ? { _bundleProductTitle: meta.title } : {}),
          ...(meta.url ? { _bundleProductUrl: meta.url } : {}),
          ...(meta.image ? { _bundleProductImage: meta.image } : {})
        }
      };
    });
  }

  function install() {
    const state = window.FTRLoopBundle;
    if (!state?.prepareCartItems) {
      clearTimeout(installTimer);
      installTimer = setTimeout(install, 50);
      return;
    }

    if (state.prepareCartItems.__ftrParentMetaFixed) return;

    const previous = state.prepareCartItems.bind(state);
    const wrapped = async function(items, productInfo) {
      const prepared = await previous(items, productInfo);
      if (state.purchaseType !== 'subscription') return prepared;
      const withMeta = attachMeta(prepared);
      console.log(PREFIX, 'Parent bundle metadata attached to subscription items:', withMeta);
      return withMeta;
    };

    wrapped.__ftrParentMetaFixed = true;
    state.prepareCartItems = wrapped;
    console.log(PREFIX, 'Installed.');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install, { once: true });
  } else {
    install();
  }
})();
